import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

export const HeaderTitle = styled.span`
  ${typographyMixin("subtitle", 2)}
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ModalSubtitle = styled.p`
  margin: ${spacing[1]} 0 0;
  max-width: 100%;
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

/** Constrains wide inner content to the modal width (avoids horizontal page scroll). */
export const ModalBodyFrame = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
`;

export const TableCard = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${({ theme }) => theme.borders.radius.lg};
  overflow: hidden;
  background-color: ${rawColors.structural.white};
`;

export const ListScroll = styled.div`
  max-height: min(62vh, 72dvh);
  overflow-x: hidden;
  overflow-y: auto;
`;

export const FooterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing[3]};
  width: 100%;
  min-width: 0;
  flex-shrink: 0;
`;

export const CenteredState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing[3]};
  padding: ${spacing[8]} ${spacing[4]};
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ErrorText = styled.p`
  margin: 0 0 ${spacing[3]};
  ${typographyMixin("body", 4)}
  color: ${rawColors.accent.red500};
`;
